<!--  -->
<template>
  <div>
    
      <el-form :model="ruleForm" :inline="true" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="年" prop="year">
            <el-date-picker style="width:200px" value-format="yyyy" v-model="ruleForm.year" type="year" placeholder="选择年"> </el-date-picker>
          </el-form-item>
          <el-form-item label="季度" prop="quarter">
            <el-select  v-model="ruleForm.quarter"  clearable placeholder="请选择" style="width:200px">
              <el-option :key="index" v-for="(item,index) in quarterList" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-row type="flex" justify="center" align="middle">
            <el-button type="primary" @click="exportFarm('ruleForm')">导出</el-button></el-button></el-button>
            <el-button @click="close">取消</el-button>
          </el-row>
        </el-form>

  </div>
</template>

<script>
import proteinDrug from "@/api/rmcProtein/drug";
import { fileService } from "@/api/common/file-utils";
import prodMedicine from "@/api/rmcProduce/prodMedicine";

export default {
  props:['exportTitle','exportType'],
  data () {
    return {
        quarterList:[{
            name:"Q1",
            code:"1"
        },{
            name:"Q2",
            code:"2"
        },{
            name:"Q3",
            code:"3"
        },{
            name:"Q4",
            code:"4"
        }],
        ruleForm:{},
        rules: {
            year: [
                { required: true, message: '请选择年份', trigger: 'change' }
            ],
            quarter: [
                { required: true, message: '请选择季度', trigger: 'change' }
            ],
        }
    };
  },

  components: {},

  computed: {},

  methods: {
      exportFarm(formName){
        this.$refs[formName].validate((valid) => {
            if (valid) {
                let str=this.quarterList.filter((v)=>{
                return v.code==this.ruleForm.quarter
                })
                if(this.exportTitle=='Protein'){
                    proteinDrug.exportMedicineSnapshot(this.ruleForm).then((res)=>{
                        fileService.respToFile(res,'Protein_药品季度清单.xlsx');
                        // fileService.respToFile(res,'Protein_药品清单季度报表'+'_'+this.ruleForm.year+'_'+str[0].name+'.xlsx');
                        this.$emit('closeExport')
                    })
                }else if(this.exportTitle=='Produce'){
                    prodMedicine.exportSnapshot(this.ruleForm).then((res)=>{
                        fileService.respToFile(res,'Produce_药品季度清单.xlsx');
                        // fileService.respToFile(res,'Produce_药品清单季度报表'+'_'+this.ruleForm.year+'_'+str[0].name+'.xlsx');
                        this.$emit('closeExport')
                    })
                }
                
            } else {
                console.log('error submit!!');
                return false;
            }
        });
    },
    close(){
        this.$emit('closeExport')
    }
  }
}

</script>
<style  scoped>
</style>